var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-btn l-icon l-icon-help"},[_c('div',{staticClass:"mini-menu-Overall"},[_c('div',{staticClass:"mini-menu-Overall-item"},[_vm._v("新手指南")]),_c('div',{staticClass:"mini-menu-Overall-item"},[_vm._v("视频教程")])])])
}]

export { render, staticRenderFns }